import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'
import type { IJSONRips } from '@/modules/Financiera/interfaces/IJsonRips'
export class JSONRipsService extends BaseService<IJSONRips> {
  constructor() {
    super({
      baseUrl: 'financiera/rips/'
    })
  }
  async generateJsonRips(
    id: string,
    type: 'con-validacion' | 'sin-validacion',
    data: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IJSONRips[]>>> {
    return this.http.post<IResponseApi<IJSONRips[]>>(`/generar/${id}/${type}`, data)
  }

  async generateExcelRips(
    id: string,
    type: 'con-validacion' | 'sin-validacion',
    data: Record<string, unknown>
  ): Promise<AxiosResponse<Blob>> {
    return this.http
      .post<Blob>(`/excel/${id}/${type}`, data, { responseType: 'blob' })
      .catch(this.errorHandle)
  }
}
